var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":_vm.visibilityColor,"text-color":"white"}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(_vm.visibilityIcon))]),_vm._v(" "+_vm._s(_vm.visibilityText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }